<template>
  <div id="app">
    <nav class="nav-pri">
      <img class="logo" src="./assets/P3F-Stamp-RGB-white.png" alt="P3F logo">
      <ul>
        <li>
          <span class="cat">E-Commerce</span>
          <ul>
            <li><a href="#">Intégration des produits via un fichier Excel</a></li>
          </ul>
        </li>
      </ul>
    </nav>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="scss">
  @import '../node_modules/bootstrap/scss/bootstrap.scss';
  @import './main.scss';
</style>


// WEBPACK FOOTER //
// src/App.vue